import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import ApiService from '@/services/common/api.service';
import StorageService from "@/services/common/storage.service";

const VoucherService = {
    getVoucherByCash,
    getVoucherDetails,
    getVoucherByGroupTypes,
    addVoucher,
    addVoucherContract,
    updateContract,
    deleteVoucher,
    forceDeleteContract,
    list,
    details,
    remove,
    upload,
    checkPwdPdf,
    getPdf,
    contracts,
    subContracts,
};

async function list (cahsId = "", currencyId = "", screenType = "", groupType = "") {
    try {
        let url = `${process.env.API_URL}/vouchers`;
        if (cahsId) {
            url += `?cashId=` + cahsId;
        }
        if (currencyId && screenType == Constants.CashScreenType) {
            url += `&currencyId=` + currencyId;
        }
        if (screenType) {
            url += `&cashInOutType=` + screenType;
            if (screenType == Constants.ExchangeScreenType) {
                url += `&voucherType=` + Constants.VoucherType.currency_exchange_receipt_cash.id;
            }
        }
        if (groupType) {
            if (groupType == Constants.GroupVoucherType.cash_detail) {
                url += `&`;
            } else {
                url += `?`;
            }
            url += `groupType=` + groupType;
        }
        let user = JSON.parse(StorageService.getUser());
        let groups = user.groups[0];
        url += `&groupId=` + groups.id;
        let tour = JSON.parse(StorageService.getTour());
        let tourNumber = "";
        if (tour) {
            tourNumber = tour.tour_number;
        } else {
            // 別ユーザの情報も表示してしまうため、暫定対応で、ツアーの指定がない場合は一覧表示しない
            return {status: 200, data:{}};
        }
        url += `&tourNumber=` + tourNumber;
        let requestData = {
            method: 'get',
            url: url,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function contracts (screenType) {
    try {
        const user = JSON.parse(StorageService.getUser());
        const groups = user.groups[0];
        const tour = JSON.parse(StorageService.getTour());
        let tourNumber = "";
        if (tour) {
            tourNumber = tour.tour_number;
        } else {
            // 別ユーザの情報も表示してしまうため、暫定対応で、ツアーの指定がない場合は一覧表示しない
            return {status: 200, data:{}};
        }
        let url = `/vouchers/contracts?tourNumber=${tourNumber}&screenType=${screenType}`;
        if (!Utils.isEmptyStr(groups.id)) {
            url += `&groupId=${groups.id}`;
        }
        return await ApiService.get(url);
    } catch (err) {
        return err;
    }
}

async function subContracts (voucherType) {
    try {
        const user = JSON.parse(StorageService.getUser());
        const groups = user.groups[0];
        const tour = JSON.parse(StorageService.getTour());
        let tourNumber = "";
        if (tour) {
            tourNumber = tour.tour_number;
        } else {
            // 別ユーザの情報も表示してしまうため、暫定対応で、ツアーの指定がない場合は一覧表示しない
            return {status: 200, data:{}};
        }
        let url = `/vouchers/subContracts?tourNumber=${tourNumber}&voucherType=${voucherType}`;
        if (!Utils.isEmptyStr(groups.id)) {
            url += `&groupId=${groups.id}`;
        }
        return await ApiService.get(url);
    } catch (err) {
        return err;
    }
}

async function details (id) {
    let url = '/vouchers/' + id;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function remove (id) {
    try {
        let requestData = {
            method: 'delete',
            url: `${process.env.API_URL}/vouchers/` + id,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function getVoucherByCash (cashId = "", currencyId = "") {
    let url = '/vouchers?cashId=' + cashId + '&currencyId=' + currencyId;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getVoucherDetails (voucherId = "") {
    let url = '/vouchers/' + voucherId;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getVoucherByGroupTypes (groupType = "") {
    let url = '/vouchers?groupType=' + groupType;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function addVoucher (id, params) {
    try {
        let response = null;

        if (!Utils.isEmptyStr(params.transactionDate)) {
            params.transactionDate = DateUtils.formatDateDefault(params.transactionDate);
        }

        // params._token = Utils.generateRandomString();
        if (!Utils.isEmptyStr(id)) {
            let url = '/vouchers/' + id;
            response = await ApiService.put(url, params);
        } else {
            let user = StorageService.getUser();
            let groups;
            if (user) {
                user = JSON.parse(user);
                if (user.groups[0]) {
                    groups = user.groups[0];
                }
                params.groupId = groups.id;
            } else {
                params.groupId = "";
            }
            let url = '/vouchers';
            response = await ApiService.post(url, params);
        }

        return response;
    } catch (error) {
        return error;
    }
}

async function addVoucherContract (params, id = "") {
    try {
        let response = null;

        if (!Utils.isEmptyStr(params.transactionDate)) {
            params.transactionDate = DateUtils.formatDateDefault(params.transactionDate);
        }

        // params._token = Utils.generateRandomString();
        if (!Utils.isEmptyStr(id)) {
            let url = '/vouchers/check-in/' + id;
            response = await ApiService.put(url, params);
        } else {
            let user = StorageService.getUser();
            let groups;
            if (user) {
                user = JSON.parse(user);
                if (user.groups[0]) {
                    groups = user.groups[0];
                }
                params.groupId = groups.id;
            } else {
                params.groupId = "";
            }
            let url = '/vouchers/contracts';
            response = await ApiService.post(url, params);
        }

        return response;
    } catch (error) {
        return error;
    }
}

async function updateContract (params) {
    try {
        let response = null;

        if (!Utils.isEmptyStr(params.transactionDate)) {
            params.transactionDate = DateUtils.formatDateDefault(params.transactionDate);
        }

        let user = StorageService.getUser();
        let groups;
        if (user) {
            user = JSON.parse(user);
            if (user.groups[0]) {
                groups = user.groups[0];
            }
            params.groupId = groups.id;
        } else {
            params.groupId = "";
        }

        let url = '/vouchers/update-contract/' + params.id;
        response = await ApiService.put(url, params);

        return response;
    } catch (error) {
        return error;
    }
}

async function deleteVoucher (voucherId = "") {
    let url = '/vouchers/' + voucherId;
    try {
        let response = await ApiService.delete(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function forceDeleteContract (contractId = "") {
    const url = `/vouchers/contracts/${contractId}`;
    try {
        const response = await ApiService.delete(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function upload (formData) {
    try {
        let requestData = {
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${process.env.API_URL}/uploadfile/`,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function checkPwdPdf (formData) {
    try{
        let requestData = {
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${process.env.API_URL}/checkPwdPdf/`,
        }
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

// async function getPdf(id = "") {
//     let url = '/vouchers/' + id + '/file';
//     try {
//         let response = await ApiService.get(url);
//         return response;
//     } catch (error) {
//         return error;
//     }
// }

async function getPdf (id) {
    try {
        let requestData = {
            method: 'get',
            responseType: 'arraybuffer',
            url: `${process.env.API_URL}/vouchers/` + id + `/file`,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

export default VoucherService;



// WEBPACK FOOTER //
// ./src/services/module/voucher.service.js